<script setup>
import {computed, watch} from 'vue';
import Card from "primevue/card"
import DataTable from "primevue/datatable"
import Column from "primevue/column"
import InputText from "primevue/inputtext";
import InputIcon from "primevue/inputicon";
import IconField from "primevue/iconfield";
import { useServerTable } from "@/composables/useServerTable.js";
import { useWorksStore } from '@/stores/work.js';
import Button from "primevue/button";

const props = defineProps({
  customerId: { type: [Number, String], required: false },
  facilityId: { type: [Number, String], required: false },
  contractId: { type: [Number, String], required: false },
  status: { type: String, default: 'ACTIVE' },
});

const store = useWorksStore();
const showControls = computed(() => loading.value || totalRecords.value > 0);

const {
  data: works,
  totalRecords,
  loading,
  rowsPerPage,
  onPageChange,
  setSearch,
  setExtra,
  firstIndex,
} = useServerTable({
  initialRows: 10,
  debounceMs: 500,
  loadPage: params => store.loadWorksList(params),
});

// Следим за изменением props и обновляем параметры для useServerTable
watch(
    () => [props.customerId, props.facilityId, props.contractId, props.status],
    ([customer, facility, contract, status]) => {
      setExtra({ customer, facility, contract, status });
    },
    { immediate: true }
);
</script>

<template>
  <Card>
    <template #title>
      <div class="w-full flex items-center justify-between px-4 gap-3 text-lg">
        <span>Работы</span>
        <div class="flex items-center gap-2">

        <IconField v-if="showControls">
          <InputIcon class="pi pi-search" />
          <InputText placeholder="Поиск работ..." size="small" @update:modelValue="setSearch" />
        </IconField>
        <Button icon="pi pi-plus" rounded text size="small"/>
        </div>
      </div>
    </template>
    <template #content>
      <DataTable
          :value="works"
          lazy
          :paginator="totalRecords > rowsPerPage"
          :rows="rowsPerPage"
          :totalRecords="totalRecords"
          :loading="loading"
          :first="firstIndex()"
          @page="onPageChange"
          paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink"
          currentPageReportTemplate="от {first} до {last} из {totalRecords}"
          emptyMessage="Работ нет"
          class="text-sm"
      >
        <Column field="item_name">
          <template #body="{ data }">
            <router-link :to="`/works/${data.id}`" class="hover:underline">
              <i class="pi pi-clipboard text-xs text-gray-500 mr-2 align-middle"></i>
              {{ data.item_name || data.name }}
            </router-link>
            <p class="text-xs text-gray-500"> {{ data.status?.item_name || data.status?.name }}</p>
          </template>
        </Column>
      </DataTable>
    </template>
  </Card>
</template>

<style scoped>
:deep(.p-datatable-thead > tr > th),
:deep(.p-datatable-tbody > tr > td) {
  border: none !important;
  background: transparent !important;
  border-bottom: none !important;
}
:deep(.p-datatable-tbody > tr > td) {
  padding-top: 6px !important;
  padding-bottom: 4px !important;
}
:deep(.p-datatable-thead > tr > th) {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
:deep(.p-paginator .p-paginator-prev),
:deep(.p-paginator .p-paginator-next) {
  height: 2rem;
  min-width: 2rem;
}
:deep(.p-card-body) {
  padding: 2px 0 8px;
}
</style>